import { Point } from '@nivo/line'

interface MultiPoint {
  points?: Array<Point>
}

type ChartPoint = Point & MultiPoint

type DateSetter = (date: Date) => void

const isValidDate = (date: unknown): date is Date => {
  return date instanceof Date && !isNaN(date.getTime())
}

const toDate = (value: unknown): Date | null => {
  if (value == null) {
    return null
  }

  if (isValidDate(value)) {
    return value
  }

  if (typeof value === 'number' || typeof value === 'string') {
    const date = new Date(value)
    return isValidDate(date) ? date : null
  }

  return null
}

const extractDateFromPoint = (point: ChartPoint): Date | null => {
  const dateLocations = [
    point?.data?.x,
    point?.data?.xFormatted,
    point?.points?.[0]?.data?.x,
    point?.points?.[0]?.data?.xFormatted,
    point?.points?.[1]?.data?.x,
    point?.points?.[1]?.data?.xFormatted,
  ]

  for (const location of dateLocations) {
    const date = toDate(location)
    if (date) {
      return date
    }
  }

  return null
}

export const onSingleDomainClick = (point: Point | any, setDate: DateSetter): void => {
  const clickedDate = extractDateFromPoint(point)

  if (clickedDate) {
    setDate(clickedDate)
  }
}
